// src/shared/components/CommonTextField.tsx
import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {CommonTextFieldProps} from "../services/interface"

const CommonTextField: React.FC<CommonTextFieldProps> = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  required = false,
  error = false,
  helperText = "",
  placeholder = "",
  fullWidth = true,
  disabled = false,
  multiline = false,
  rows = 1,
  onBlur,
  onBlurCapture,
  onFocus,
  onClick,
  style,
  className, 
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";
  const inputType = isPassword && showPassword ? "text" : type;
  return (
    <TextField
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      type={inputType}
      required={required}
      error={error}
      helperText={helperText}
      placeholder={placeholder}
      fullWidth={fullWidth}
      disabled={disabled}
      multiline={multiline}
      rows={rows}
      variant="outlined"
      size="small"
      onBlur={onBlur}
      onFocus={onFocus}
      onClick={onClick}
      style={style}
      className={className}
       InputLabelProps={{
    sx: {
      "& .MuiInputLabel-asterisk": {
        color: "#d32f2f", // MUI default error red
      },
    },
  }}
      InputProps={
        type === "password"
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label={`toggle ${label} visibility`} onClick={() => setShowPassword((prev) => !prev)} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }
          : undefined
      }
      inputProps={{ onBlurCapture }}
    />
  );
};

export default CommonTextField;